var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2V8.5C12 8.89782 12.158 9.27936 12.4393 9.56066C12.7206 9.84196 13.1022 10 13.5 10H20V15.757L18.707 14.464C18.6141 14.3712 18.5038 14.2975 18.3824 14.2473C18.2611 14.1971 18.131 14.1713 17.9996 14.1713C17.8683 14.1713 17.7382 14.1973 17.6169 14.2476C17.4956 14.2979 17.3853 14.3716 17.2925 14.4645C17.1997 14.5574 17.126 14.6677 17.0758 14.7891C17.0256 14.9104 16.9998 15.0405 16.9998 15.1719C16.9998 15.3032 17.0258 15.4333 17.0761 15.5546C17.1264 15.6759 17.2001 15.7862 17.293 15.879L18.414 17H14C13.7348 17 13.4804 17.1054 13.2929 17.2929C13.1054 17.4804 13 17.7348 13 18C13 18.2652 13.1054 18.5196 13.2929 18.7071C13.4804 18.8946 13.7348 19 14 19H18.414L17.293 20.121C17.1054 20.3085 16.9999 20.5629 16.9998 20.8281C16.9997 21.0934 17.105 21.3479 17.2925 21.5355C17.48 21.7231 17.7344 21.8286 17.9996 21.8287C18.2649 21.8288 18.5194 21.7235 18.707 21.536L19.983 20.259C19.9201 20.7405 19.6842 21.1826 19.3194 21.5029C18.9545 21.8233 18.4855 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2H12ZM20 15.757L21.535 17.293C21.7225 17.4805 21.8278 17.7348 21.8278 18C21.8278 18.2652 21.7225 18.5195 21.535 18.707L20 20.243V15.757ZM14 2.043C14.3789 2.12336 14.7263 2.31199 15 2.586L19.414 7C19.688 7.27373 19.8766 7.62112 19.957 8H14V2.043Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.3f7db979812f7be453a32deea14cec5f.svg";
export { ForwardRef as ReactComponent };